import { TipoIstanzaFascicoloDTO } from "./tipo-istanza-fascicoloDTO";
import { ElementoVicinoDTO } from "./elemento-vicinoDTO";

export class RiferimentiPosizioneDTO {
    idPadre: string;
    oggettoPadre: string;
    tipoFascicoloPadre: TipoIstanzaFascicoloDTO;
    elementoSuperiore: ElementoVicinoDTO;
    elementoInferiore: ElementoVicinoDTO;
    posizione: number;

}